export default __webpack_public_path__ + "static/media/heart.b08a38f9.svg";